import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './shared/queryProvider';
import { ThemeProvider } from './styles/theme/ThemeProvider';
import { Application } from './app';
import { NotificationProvider } from './entites/notification';
import { setupTelegram } from './shared/utils/setupTelegram';
import { setupBrowserViewport } from './shared/utils/telegramViewport';
import { addNgrokMetaTag } from './shared/utils/ngrokUtils';
import './styles/fonts.scss';
import './styles/global.scss';
import './styles/utilities.scss';
import './styles/typography-utilities.scss';
import './styles/color-utilities.scss';

addNgrokMetaTag();
setupTelegram();

if (!window?.Telegram?.WebApp?.initData) {
  setupBrowserViewport();
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <NotificationProvider>
          <Application />
        </NotificationProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
